import { useState } from 'react';
import { CustomDialogProps } from '@/dashboard/components/Dialog/index';
import PolicyModel from '@/dashboard/models/policys/PolicyModel';
import { Dayjs } from 'dayjs';
import PauseConfirmView from './confirm';
import FormEditView from './form';
import { PausePolicyHandleType } from './types';

type PausePolicyDialogViewProps = CustomDialogProps & {
  policy: PolicyModel;
  pauseType?: PausePolicyHandleType;
};
const PausePolicyDialogView = (props: PausePolicyDialogViewProps) => {
  const { close, policy, pauseType = 'pause' } = props;
  const [step, setStep] = useState(1);
  const [submitInfo, setSubmitInfo] = useState<{ startDate: Dayjs; endDate: Dayjs }>(pauseType === 'edit' ? { startDate: policy.pauseStartDateDayjs, endDate: policy.pauseEndDateDayjs } : undefined);

  /**
   * methods
   */
  const continuePauseAction = (info) => {
    setStep(2);
    setSubmitInfo(info);
  };

  return (
    <>
      {step === 1 && <FormEditView policy={policy} close={close} confirm={continuePauseAction} info={submitInfo} pauseType={pauseType} />}
      {step === 2 && <PauseConfirmView policy={policy} close={close} back={() => setStep(1)} info={submitInfo} pauseType={pauseType} />}
    </>
  );
};

export default PausePolicyDialogView;
